/* Winter Collection — interactions
   Progressive enhancement: with JS off the page still reads top to bottom,
   anchors still jump, rails still scroll natively, filters show everything
   and the FAQ still opens (it is built on <details>). */
(function () {
  'use strict';
  if (window.__wcBooted) return;
  window.__wcBooted = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* Anchor clearance -------------------------------------------------------
     Ask the page what is actually painted over the top of the viewport rather
     than guessing from header class names, which differ per theme. */
  function overlayBottom() {
    var bottom = 0;
    var xs = [Math.round(window.innerWidth / 2), 10, window.innerWidth - 10];
    for (var i = 0; i < xs.length; i++) {
      for (var y = 2; y <= 190; y += 12) {
        var el = document.elementFromPoint(xs[i], y), hops = 0;
        while (el && el !== document.body && el !== document.documentElement && hops++ < 12) {
          var pos = getComputedStyle(el).position;
          if (pos === 'fixed' || pos === 'sticky') {
            var r = el.getBoundingClientRect();
            if (r.top <= 4 && r.bottom > bottom && r.bottom < 260) bottom = r.bottom;
            break;
          }
          el = el.parentElement;
        }
      }
    }
    return bottom;
  }
  function syncAnchor() {
    document.documentElement.style.setProperty('--wc-anchor', Math.round(overlayBottom() + 16) + 'px');
  }
  function anchorPx() {
    var v = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--wc-anchor'), 10);
    return isNaN(v) ? 80 : v;
  }

  /* Scrolling --------------------------------------------------------------
     Native smooth scroll takes close to a second across a page this long,
     which reads as lag. Ease it in ~430ms and let any gesture cancel it. */
  var raf = null;
  function cancelScroll() { if (raf) { cancelAnimationFrame(raf); raf = null; } }
  ['wheel', 'touchstart', 'pointerdown'].forEach(function (e) {
    window.addEventListener(e, cancelScroll, { passive: true });
  });

  function settle(el) {
    var want = overlayBottom() + 16;
    var delta = el.getBoundingClientRect().top - want;
    if (Math.abs(delta) > 2) window.scrollBy(0, delta);
    syncAnchor();
  }
  function smoothTo(el) {
    if (!el) return;
    syncAnchor();
    var y = Math.max(0, window.scrollY + el.getBoundingClientRect().top - anchorPx());
    var start = window.scrollY, dist = y - start;
    function done() { settle(el); setTimeout(function () { settle(el); }, 140); }
    if (reduceMotion.matches || Math.abs(dist) < 4) { window.scrollTo(0, y); done(); return; }
    cancelScroll();
    var dur = Math.min(430, Math.max(260, Math.abs(dist) * 0.2));
    var t0 = performance.now();
    (function step(t) {
      var p = Math.min(1, (t - t0) / dur);
      window.scrollTo(0, start + dist * (1 - Math.pow(1 - p, 3)));
      if (p < 1) raf = requestAnimationFrame(step); else { raf = null; done(); }
    })(t0);
  }

  /* Intent tiles and any in-page jump */
  function bindGoto(root) {
    root.querySelectorAll('[data-wc-goto]').forEach(function (el) {
      if (el.dataset.wcBound) return;
      el.dataset.wcBound = '1';
      el.addEventListener('click', function (e) {
        var sel = el.dataset.wcGoto;
        var target = document.querySelector(sel);
        if (!target) return;           // let a real link fall through
        e.preventDefault();
        smoothTo(target);
      });
    });
  }

  /* Rails ------------------------------------------------------------------ */
  function primeImages(rail) {
    rail.querySelectorAll('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
  }
  function initRail(rail) {
    if (rail.dataset.wcBound) return;
    rail.dataset.wcBound = '1';

    // An image parked off to the right can stay undecoded until swiped to,
    // which reads as a blank card. Promote them once the rail is in view.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { primeImages(rail); io.disconnect(); } });
      }, { rootMargin: '400px 0px' });
      io.observe(rail);
    } else primeImages(rail);

    var nav = document.querySelector('[data-wc-railnav="' + rail.dataset.wcRail + '"]');
    var prev = nav && nav.querySelector('[data-dir="prev"]');
    var next = nav && nav.querySelector('[data-dir="next"]');

    function step() {
      var first = rail.firstElementChild;
      if (!first) return rail.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 16;
      return first.getBoundingClientRect().width + gap;
    }
    function sync() {
      if (!nav) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
      nav.hidden = max <= 2;
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduceMotion.matches ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduceMotion.matches ? 'auto' : 'smooth' }); });

    rail.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(rail);
    rail.querySelectorAll('img').forEach(function (i) { if (!i.complete) i.addEventListener('load', sync, { once: true }); });
    sync();

    if (!canHover.matches) return;      // touch scrolls natively; leave it alone
    var down = false, sx = 0, sl = 0, moved = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = 0; sx = e.clientX; sl = rail.scrollLeft;
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 4) { moved = Math.abs(dx); rail.classList.add('is-dragging'); }
      rail.scrollLeft = sl - dx;
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
      rail.addEventListener(evt, function () {
        if (!down) return;
        down = false;
        // a real drag must not also fire quick view or add to cart
        if (moved > 4) rail.addEventListener('click', function s(ev) { ev.stopPropagation(); ev.preventDefault(); }, { capture: true, once: true });
        rail.classList.remove('is-dragging');
      });
    });
  }

  /* Vegetable filters ------------------------------------------------------ */
  function initFilters(group) {
    if (group.dataset.wcBound) return;
    group.dataset.wcBound = '1';
    var grid = document.querySelector('[data-wc-filter-target="' + group.dataset.wcFilters + '"]');
    if (!grid) return;
    var buttons = group.querySelectorAll('[data-wc-filter]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.wcFilter;
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        grid.querySelectorAll('[data-wc-group]').forEach(function (card) {
          card.hidden = !(key === 'all' || card.dataset.wcGroup === key);
        });
      });
    });
  }

  /* Add-to-cart feedback ---------------------------------------------------
     A one-second flurry from the button that was pressed, plus a short
     confirmation. Fires on submit so it only celebrates a real add, and is
     transform/opacity only so it stays smooth on a phone. */
  var FLAKE_COLOURS = ['#4db3d6', '#ffffff', '#4db3d6', '#96c2db'];
  var toastEl = null, toastTimer = null;

  function showToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'wc-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    // restart cleanly if two adds land close together
    clearTimeout(toastTimer);
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 1900);
  }

  function burstAt(x, y) {
    if (reduceMotion.matches) return;
    var layer = document.createElement('div');
    layer.className = 'wc-burst';
    layer.setAttribute('aria-hidden', 'true');
    var n = window.innerWidth < 750 ? 11 : 16;
    for (var i = 0; i < n; i++) {
      var a = (Math.PI * 2 * i) / n + Math.random() * 0.5;
      var dist = 48 + Math.random() * 62;
      var f = document.createElement('i');
      f.style.left = x + 'px';
      f.style.top = y + 'px';
      f.style.setProperty('--dx', Math.cos(a) * dist + 'px');
      f.style.setProperty('--dy', (Math.sin(a) * dist - 26) + 'px');
      f.style.setProperty('--r', (Math.random() * 300 - 150) + 'deg');
      f.style.setProperty('--s', (7 + Math.random() * 7).toFixed(1) + 'px');
      f.style.setProperty('--flake', FLAKE_COLOURS[i % FLAKE_COLOURS.length]);
      f.style.animationDelay = (Math.random() * 90).toFixed(0) + 'ms';
      layer.appendChild(f);
    }
    document.body.appendChild(layer);
    setTimeout(function () { layer.remove(); }, 1150);
  }

  function initCartFeedback() {
    var lastFire = 0;
    var SEL = '.wc-card__form [name=add], .wc-bundle__form [name=add], .wc-starter__buy [name=add]';

    function fire(btn) {
      var now = Date.now();
      if (now - lastFire < 600) return;   // one flurry per add, not per event
      lastFire = now;
      var r = btn.getBoundingClientRect();
      burstAt(r.left + r.width / 2, r.top + r.height / 2);
      showToast('\u2744\ufe0f Added to your winter garden!');
    }

    /* Not on submit: the theme's mz-add-to-cart bridge intercepts the click
       and calls stopImmediatePropagation, so the form never fires submit at
       all. pointerdown lands first and is never cancelled — which also
       matches the bridge's own optimistic tick, so the two agree. */
    document.addEventListener('pointerdown', function (e) {
      var btn = e.target.closest && e.target.closest(SEL);
      if (btn && !btn.disabled) fire(btn);
    }, true);

    // keyboard activation never produces a pointerdown
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var btn = e.target.closest && e.target.closest(SEL);
      if (btn && !btn.disabled) fire(btn);
    }, true);
  }

  /* Reveal ----------------------------------------------------------------- */
  function initReveal(root) {
    var items = root.querySelectorAll('.wc-reveal:not([data-wc-seen])');
    if (!items.length) return;
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    items.forEach(function (el) { el.dataset.wcSeen = '1'; io.observe(el); });
  }

  var feedbackReady = false;
  function init(root) {
    root = root || document;
    if (!feedbackReady) { initCartFeedback(); feedbackReady = true; }
    bindGoto(root);
    root.querySelectorAll('[data-wc-rail]').forEach(initRail);
    root.querySelectorAll('[data-wc-filters]').forEach(initFilters);
    initReveal(root);
    syncAnchor();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.addEventListener('resize', syncAnchor);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
